// extracted by mini-css-extract-plugin
module.exports = {"notifications":"NotificationCheckboxes_notifications__1Tuzx","text":"NotificationCheckboxes_text__1KyWe"};